import * as Types from '../../../generated.types'

import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type TosAcceptanceQueryVariables = Types.Exact<{
  ownerId: Types.Scalars['Int']
}>

export type TosAcceptanceQuery = {
  __typename?: 'Query'
  organization?: {
    __typename?: 'Organization'
    id: number
    acceptance?: {
      __typename?: 'Acceptance'
      id: number
      acceptedAt?: string | null
      formUrl?: string | null
      accepter: { __typename?: 'AcceptanceAccepter'; id: number }
      signedDocument?: { __typename?: 'File'; url?: string | null } | null
      agreement: { __typename?: 'Agreement'; id: number; isMostRecent: boolean }
    } | null
    esignAcceptance?: { __typename?: 'Acceptance'; id: number; acceptedAt?: string | null } | null
  } | null
}

export const TosAcceptanceDocument = `
    query TOSAcceptance($ownerId: Int!) {
  organization(id: $ownerId) {
    id
    acceptance(type: "pth_organization_tos") {
      id
      acceptedAt
      formUrl
      accepter {
        id
      }
      signedDocument {
        url
      }
      agreement {
        id
        isMostRecent
      }
    }
    esignAcceptance: acceptance(type: "user_esign_consent") {
      id
      acceptedAt
    }
  }
}
    `
export const useTosAcceptanceQuery = <TData = TosAcceptanceQuery, TError = Error>(
  variables: TosAcceptanceQueryVariables,
  options?: UseQueryOptions<TosAcceptanceQuery, TError, TData>
) =>
  useQuery<TosAcceptanceQuery, TError, TData>(
    ['TOSAcceptance', variables],
    fetchGql<TosAcceptanceQuery, TosAcceptanceQueryVariables>(TosAcceptanceDocument, variables),
    options
  )

useTosAcceptanceQuery.getKey = (variables: TosAcceptanceQueryVariables) => ['TOSAcceptance', variables]
